import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "./ui/accordion";
import SectionHeading from "./SectionHeading";
import { FadeUp } from "./Reveal";
import { FAQ } from "../data/site";

export default function Faq() {
    return (
        <section
            data-testid="faq-section"
            className="bg-white py-20 sm:py-28 md:py-32"
        >
            <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 sm:px-8 md:px-12 lg:grid-cols-12">
                <div className="lg:col-span-5">
                    <SectionHeading
                        overline="Domande Frequenti"
                        title="Le risposte che cerchi, prima ancora di chiederle."
                        lead="Se non trovi la tua domanda, scrivici su WhatsApp: rispondiamo in giornata."
                        testid="faq-heading"
                    />
                </div>
                <FadeUp delay={0.15} className="lg:col-span-7">
                    <Accordion
                        type="single"
                        collapsible
                        className="w-full"
                        data-testid="faq-accordion"
                    >
                        {FAQ.map((f, i) => (
                            <AccordionItem
                                key={f.q}
                                value={`faq-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="border-b border-line"
                            >
                                <AccordionTrigger className="py-6 text-left font-serif text-lg font-medium text-ink transition-colors hover:text-petrol hover:no-underline sm:text-xl">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-6 text-base font-light leading-relaxed tracking-wide text-body">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </FadeUp>
            </div>
        </section>
    );
}
